const formatearPesosColombianos = (valor) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(valor);
}


export default formatearPesosColombianos


// WEBPACK FOOTER //
// ./src/global-services/formatear-pesos.js